import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpCreateAccess, HttpCreateAccessOptions} from '../http/accesses.http'
import {errorHandler} from '@/utilities/helpers'

export const useCreateAccess = (
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpCreateAccessOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationFn: payload => httpCreateAccess({payload}),
        onSuccess: async (data, variables, context) => {
            await options?.onSuccess?.(data, variables, context)
        },
        onError: (error, variables, context) => {
            errorHandler(error)
            options?.onError?.(error, variables, context)
        }
    })
}
